import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { providePrimeNG } from 'primeng/config';

import * as echarts from 'echarts/core';
import { provideEchartsCore } from 'ngx-echarts';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, LineChart, PieChart, GaugeChart, RadarChart, ScatterChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, GridComponent, LegendComponent, ToolboxComponent, RadarComponent, GraphicComponent } from 'echarts/components';
import 'echarts/theme/dark.js'; // Importa el tema dark.js

import { appRoutes } from './app.routes';
import { SergloPrimengPreset } from './app.palette';
import { ExternalConfService } from '@core/services/external-conf.service';
import { ConsoleInterceptor } from '@core/interceptors/console.interceptor';
import { AuthTokenInterceptor } from '@core/auth/interceptors/auth-token.interceptor';
import { AuthErrorInterceptor } from '@core/auth/interceptors/auth-error.interceptor';
import { AuthService } from '@core/auth/services/auth.service';
import { appModeInitializer } from '@core/initializers/app-mode.initializer';
import { AppModeService } from '@core/services/app-mode.service';
import { DiccionarioService } from '@core/services/diccionario.service';
import { IndiceService } from '@features/admin/indice/services/indice.service';

registerLocaleData(localeEs);

echarts.use ([
   CanvasRenderer,
   TooltipComponent,
   GridComponent,
   TitleComponent,
   BarChart,
   PieChart,
   LegendComponent,
   LineChart,
   GaugeChart,
   RadarChart,
   RadarComponent,
   GraphicComponent,
   ToolboxComponent,
   ScatterChart
]);

export const appConfig: ApplicationConfig = {
   providers: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
      provideHttpClient(withInterceptorsFromDi()), // QUITADO withFetch() para mejor compatibilidad CORS
      provideAnimationsAsync(),
      provideEchartsCore({ echarts, theme: 'dark' }),
      providePrimeNG({
         theme: {
            preset: SergloPrimengPreset,
            options: {
               ripple: true,
               darkModeSelector: '.app-dark',
               // cssLayer: {
               //    name: 'primeng',
               //    order: 'tailwind, primeng, layout, demo',
               // }
            }
         },
         ripple: true
      }),
      {
         provide: APP_INITIALIZER,
         useFactory: (confExterna: ExternalConfService) => () => confExterna.loadConfig(),
         deps: [ExternalConfService],
         multi: true
      },
      {
         provide: APP_INITIALIZER,
         useFactory: appModeInitializer,
         deps: [AppModeService, IndiceService, AuthService, DiccionarioService],
         multi: true
      },
      ConsoleInterceptor,
      {
         provide: HTTP_INTERCEPTORS,
         useClass: AuthTokenInterceptor,
         multi: true
      },
      // INTERCEPTOR DE ERROR EN AUTH ERROR PARA SESION EXPIRADA
      {
         provide: HTTP_INTERCEPTORS,
         useClass: AuthErrorInterceptor,
         multi:true
      }
   ]
};
